import React from 'react';
import miners from './miners.json';
import Markdown from 'react-markdown'
import { IndicesFromKey } from './utils.js';

const nGridRows = 7;
const nGridColumns = 7;
const gridSquareLength = 50;
const l = gridSquareLength / 2;
const r = l * 0.8;


export default function Instructions() {
  return (<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
    <Markdown>
      {`# Instructions
      
The game starts with a grid containing resource deposits indicated by numbers. 
The higher the number, the more resources available at the deposit.
Each deposit also has a multiplier which can increase the amount of resources mined from the deposit in the top right corner.

Below is an example of a resource deposit with 1 out of 2 left and a multiplier of 1.2x.`}
    </Markdown>

    <div style={{ position: 'relative', width: '50px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'solid', borderWidth: '1px'}}>
      <p className='prevent-select' style={{ position: 'absolute', top: 0, right: 0, margin: 0, fontSize: '12px' }}>x1.2</p>
      <p className='prevent-select' style={{ margin: 0 }}>1/2</p>
    </div>

    <Markdown>{`Mine deposits by placing miners next to them (by dragging and dropping them into the tiles). Each tile can only contain a resource deposit or a miner.

Rotate miners by clicking on them in the grid.

Arrange the miners in the grid to maximize the mining rate. Different miners mine at different rates and have different ranges.`}
    </Markdown>
    <Markdown>
      {`# Miners
      
Each miner mines every square within its range at the stated efficiency.
      
The efficiency at which it mines from a certain tile within its range is listed in the tile in the illustrations below.

Some miners have support ranges which boost the efficiencies of miners in its support range.`}
    </Markdown>

    {Object.entries(miners).map(([key, value]) => {
      return (
        <>
          <Markdown>{`## ${key}`}</Markdown>

          {value['description'] !== undefined && <Markdown>{value['description']}</Markdown>}

          <Markdown>### Range</Markdown>


          <div
            style={{
              display: 'grid',
              gridTemplateRows: `repeat(${nGridRows}, ${gridSquareLength}px)`,
              gridTemplateColumns: `repeat(${nGridColumns}, ${gridSquareLength}px)`,
            }}>
            <div className='unit' style={{
              gridRow: `${Math.floor(nGridRows / 2) + 1}`,
              gridColumn: `${Math.floor(nGridColumns / 2) + 1}`,
            }}>
              <p>{key}</p>
              <svg width={`${gridSquareLength}px`} height={`${gridSquareLength}px`} style={{ position: 'absolute' }}>
                <circle cx={l} cy={l} r={r} fill='none' stroke='#d6c527' strokeWidth='2px' />
                <polyline points={`${l + Math.sqrt(3) / 2 * r},${l - 1 / 2 * r} ${2 * l},${l} ${l + Math.sqrt(3) / 2 * r}, ${l + 1 / 2 * r}`} fill="none" stroke='#d6c527' strokeWidth='2px' />
              </svg>
            </div>


            {Object.entries(value['range']).map(([position, efficiency]) => {
              const [x, y] = IndicesFromKey(position);
              return (<div style={{
                gridRow: `${Math.floor(nGridRows / 2) + 1 + y}`,
                gridColumn: `${Math.floor(nGridColumns / 2) + 1 + x}`,
                border: 'solid',
                borderWidth: '1px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                {efficiency}
              </div>);
            })}
          </div>

          {value['supportRanges'] !== undefined && <>
            <Markdown>### Support range</Markdown>
            <div
              style={{
                display: 'grid',
                gridTemplateRows: `repeat(${nGridRows}, ${gridSquareLength}px)`,
                gridTemplateColumns: `repeat(${nGridColumns}, ${gridSquareLength}px)`,
              }}>
            <div className='unit' style={{
                gridRow: `${Math.floor(nGridRows / 2) + 1}`,
                gridColumn: `${Math.floor(nGridColumns / 2) + 1}`,
              }}>
                <p>{key}</p>
                <svg width={`${gridSquareLength}px`} height={`${gridSquareLength}px`} style={{ position: 'absolute' }}>
                  <circle cx={l} cy={l} r={r} fill='none' stroke='#d6c527' strokeWidth='2px' />
                  <polyline points={`${l + Math.sqrt(3) / 2 * r},${l - 1 / 2 * r} ${2 * l},${l} ${l + Math.sqrt(3) / 2 * r}, ${l + 1 / 2 * r}`} fill="none" stroke='#d6c527' strokeWidth='2px' />
                </svg>
              </div>


              {Object.entries(value['supportRanges']).map(([position, multipler]) => {
                const [x, y] = IndicesFromKey(position);
                return (<div style={{
                  gridRow: `${Math.floor(nGridRows / 2) + 1 + y}`,
                  gridColumn: `${Math.floor(nGridColumns / 2) + 1 + x}`,
                  border: 'solid',
                  borderWidth: '1px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                  {multipler}
                </div>);
              })}
            </div>
          </>}
        </>);
    })}
  </div>);
};